var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-cta-grid l-container"},[_c('div',{staticClass:"l-grid l-grid--3-col"},_vm._l((_vm.cards),function(card){return _c('div',{key:card.handle},[(card.contentType)?_c(card.contentType,_vm._b({tag:"component",attrs:{"id":card.handle}},'component',card,false)):_vm._e()],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }